<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        :label="$t('tasks.form.watcherUsers')"
        label-for="watcher_users"
      >
        <v-select
          id="watcher_users"
          v-model="dataItem.watcher_users"
          :options="usersList"
          label="name"
          :reduce="item => item.id"
          :placeholder="$t('tasks.form.selectUserOptional')"
          :disabled="disabled"
          multiple
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        :label="$t('tasks.form.watcherTeams')"
        label-for="watcher_teams"
      >
        <v-select
          id="watcher_teams"
          v-model="dataItem.watcher_teams"
          :options="teamsList"
          label="title"
          :reduce="item => item.id"
          :placeholder="$t('tasks.form.selectTeamOptional')"
          :disabled="disabled"
          multiple
        />
        <small class="text-muted">
          {{ hintText }}
        </small>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BFormGroup, BRow } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'TasksWatchersCard',
  components: {
    BCol, BFormGroup, BRow, vSelect,
  },
  props: {
    storeModule: {
      type: String,
      default: 'tasks',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      teamsList: [],
    }
  },
  computed: {
    hintText() {
      return this.hint ?? this.$t('tasks.form.watchersHint')
    },
    usersList() {
      return this.$store.getters['users/dataList']
    },
    dataItem() {
      return this.$store.getters[`${this.storeModule}/dataItem`]
    },
  },
  async created() {
    this.teamsList = await this.$store.dispatch('teams/getSelectList')
  },
}
</script>
